import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import { FormControl } from '@angular/forms';
import {PowerBiService} from '@shared/services/power-bi.service'
import { BehaviorSubject, combineLatest, map, startWith, switchMap } from 'rxjs';

@Component({
    selector: 'app-reports-view',
    templateUrl: './reports-view.component.html',
    styleUrls: ['./reports-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportsViewComponent implements OnInit {
    _category = new BehaviorSubject<string>('');
    filterText = new FormControl<string>('');

    @Input() set category(value: string) {
        this._category.next(value);
    }

    private allReports = this._category
        .pipe(switchMap(category => {
            if (category == 'home') {
                return this.service.getReportsByUserRoles();
            } else {
                return this.service.getReportsByCategory(category);
            }
        }));

    filteredReports = combineLatest([
        this.allReports,
        this.filterText.valueChanges
            .pipe(startWith(this.filterText.value))
    ]).pipe(map(([reports, filterText]) => {
            if (filterText == '')
                return reports;

            return reports?.filter(report => report.displayName.toLowerCase().includes(filterText.toLowerCase()));
        }));


    constructor(private service: PowerBiService) {
    }

    ngOnInit() {
    }
}
